import { raven } from '@loggi/exception';
import 'babel-polyfill';
import 'moment/locale/pt-br';
import React from 'react';
import ReactDOM from 'react-dom';
import App from 'tracker.component';

if (window.loggi && window.loggi.ravenDsn) {
  raven.install(window.loggi.ravenDsn);
}

ReactDOM.render(<App />, document.getElementById('root'));
